import React from "react";
import dayjs from "dayjs";

const TimeDiff = ({date, className, withoutSuffix = false}) => {
    if(!date)return ""

    const dayjsDate = date['$d'] ? date : dayjs(date)
    return (
        <time dateTime={dayjsDate.toISOString()} data-tip={new Date(date).toLocaleString()} className={className}>
            {dayjsDate.fromNow(withoutSuffix)}
        </time>
    )
}

export default TimeDiff